import { IContacts } from '../../types/offer';
import { IOfferDesktop } from '../../repositories/offers-comparison/entities/offer/OfferDesktop';
import { phoneToString } from '../../utils/phone';

export function transformComparisonContacts({ contacts }: IOfferDesktop): IContacts {
  return {
    ...contacts,
    formattedPhone: phoneToString(contacts),
  };
}
